enum CustomDomEvents {
  VideoEnded = 'fupa-video-ended',
  VideoChanged = 'fupa-video-changed',
  PlayerLeft = 'fupa-player-left',
}

export default CustomDomEvents;
